import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import('./assets/scss/styles.scss');

import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import { mainStore, setupMqtt } from './utils/telemetryData';

import { OhVueIcon, addIcons } from 'oh-vue-icons'
import { BiBarChartFill, CoPivotaltracker, FaCarBattery, FaHome } from 'oh-vue-icons/icons'

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)

app.use(Vue3Toasity,
{
  autoClose: 6000,
})

//apexcharts
import VueApexCharts from "vue3-apexcharts";
app.use(VueApexCharts);

app.config.performance = true;

setupMqtt()

addIcons(FaHome, CoPivotaltracker, BiBarChartFill, FaCarBattery)
app.component("v-icon",OhVueIcon)
app.use(router);
app.use(mainStore);
app.mount('#app')